export default {"src":"/_next/static/media/twitter.193df4b0.svg","height":55,"width":239};